import React from 'react';
import { useQuery } from '@apollo/client';
import GoalSettingsQuery from './GoalSettingsQuery';

type result = {
  loading: boolean;
  goalSettingsData?: any;
};

interface IGoalSettingsConnectorApolloProps {
  children: (result: result) => React.ReactElement;
}

export const GoalSettingsConnectorApollo: React.FC<IGoalSettingsConnectorApolloProps> = ({
  children,
}) => {
  const { loading, data, error } = useQuery(GoalSettingsQuery);

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.goalSettingsData = data;
  }

  return children(result);
};

export default GoalSettingsConnectorApollo;
